import React from "react";
import Image from "next/image";
import clsx from "clsx";
import { Heading } from "design_system";
import Link from "next/link";
import useLabels from "hooks/useLabels";
import path from "constants/path";
import { useTheme } from "design_system/utils/theme";
import { LogoFull } from "design_system/logo";

interface AuthWrapperProps {
  heading: string;
  children: React.ReactNode;
  showLogo?: boolean;
  className?: string;
}

/**
 * A shared wrapper for auth workflows with a formatted logo and heading
 *
 * @param heading - The heading to display
 * @param children - The children to display - usually a form
 * @param showLogo - Whether to show the logo - defaults to true
 * @param className - The className to apply to the wrapper
 */
export function AuthWrapper({
  heading,
  children,
  className,
  showLogo = true,
}: AuthWrapperProps) {
  return (
    <div
      className={clsx(
        "flex flex-col gap-8 items-center justify-center w-full max-w-[448px]",
        className
      )}
    >
      <div className="w-full flex flex-col items-center gap-4">
        {showLogo && (
          <Link href={path.HOME}>
            <LogoFull height={26} />
          </Link>
        )}

        <Heading as="h2" size="sm" className="text-center">
          {heading}
        </Heading>
      </div>
      <div className="w-full">{children}</div>
    </div>
  );
}
